const common = {
  'common.loading': 'Caricamento...',
  'common.error': 'Si è verificato un errore',
  'common.success': 'Successo!',
  'common.cancel': 'Annulla',
  'common.confirm': 'Conferma',
  'common.submit': 'Invia',
  'common.save': 'Salva',
  'common.delete': 'Elimina',
  'common.edit': 'Modifica',
  'common.add': 'Aggiungi',
  'common.remove': 'Rimuovi',
  'common.continue': 'Continua',
  'common.back': 'Indietro',
  'common.next': 'Avanti',
  'common.previous': 'Precedente',
  'common.yes': 'Sì',
  'common.no': 'No',
  'common.search': 'Cerca',
  'common.filter': 'Filtra',
  'common.sort': 'Ordina',
  'common.noResults': 'Pagina non trovata',
  'common.selectOne': 'Seleziona uno',
  'common.required': 'Obbligatorio',
  'common.optional': 'Opzionale',
  'common.learnMore': 'Scopri di più',
  'common.getStarted': 'Inizia',
  'common.signUp': 'Iscriviti',
  'common.signIn': 'Accedi',
  'common.dark': 'Scuro',
  'common.light': 'Chiaro',
  'common.system': 'Sistema',
  'common.followTheme': 'Segui il tema del sistema',
  'common.language': 'Lingua',
  'common.viewMore': 'Visualizza altro',
  'common.viewLess': 'Visualizza meno',
  'common.home': 'Home',
  'common.terms': 'Termini di Servizio',
  'common.privacy': 'Politica sulla Privacy',
  'common.cookies': 'Politica sui Cookie',
  'common.contact': 'Contattaci',
  'common.contactMe': 'Contattami',
  'common.profile': 'Profilo',
  'common.settings': 'Impostazioni',
  'common.account': 'Account',
  'common.dashboard': 'Pannello di controllo',
  'common.theme.light': 'Tema Chiaro',
  'common.theme.dark': 'Tema Scuro',
  'Member Since': 'Membro dal',
  'profileNotFound': 'Profilo non trovato',
  'common.documentation': 'Documentazione API',
  
  // Navigation items
  'nav.home': 'Home',
  'nav.join': 'Unisciti a The Club',
  'nav.tutorials': 'Tutorial',
  'nav.strategies': 'Strategie',
  'nav.radex': 'Radex Markets',
  'nav.news': 'Notizie',
  
  // News translations
  'news.title': 'Ultime Notizie',
  'news.description': 'Resta aggiornato con i nostri ultimi articoli e annunci',
  'news.filterByTag': 'Filtra per tag',
  'news.allPosts': 'Tutti i Post',
  'news.noPostsFound': 'Nessun post trovato',
  'news.viewAllPosts': 'Vedi tutti i post',
  'news.backToNews': 'Torna alle Notizie',
  'news.relatedPosts': 'Post Correlati',
  'news.sharePost': 'Condividi questo post',
  'news.postNotFound': 'Post non trovato',
  'news.pagination.previous': 'Precedente',
  'news.pagination.next': 'Successivo',
  
  // Social media links - default links
  'social.instagram': 'https://www.instagram.com/theclub.finance/',
  'social.tiktok': 'https://www.tiktok.com/@the.club.fund',
  'social.youtube': 'https://www.youtube.com/@TheClub.finance',
  'social.facebook': 'https://www.facebook.com/profile.php?id=61576120443819',
  'social.telegram': 'https://t.me/theclubfund',
  
  // Footer translations
  'footer.company.description': 'The Club offre prodotti e servizi finanziari innovativi progettati per aiutarti a far crescere la tua ricchezza e raggiungere la libertà finanziaria.',
  'footer.theclub': 'The Club',
  'footer.conditions': 'Termini e Condizioni',
  'footer.customersupport': 'Assistenza clienti',
  'footer.contactuswhatsapp': 'WhatsApp',
  'footer.radex': 'Radex Markets',
  'footer.rights': 'Tutti i diritti riservati.',
  'footer.terms': 'Termini',
  'footer.privacy': 'Privacy',
  'footer.cookies': 'Cookies',
  'footer.contactUs': 'Contattaci',
  'footer.contactMe': 'Contattami',
  
  // Radex Markets translations
  'radex.hero.title': 'The Club e Partnership con Radex Markets',
  'radex.hero.subtitle': 'Scopri eccezionali opportunità di trading attraverso la nostra partnership strategica',
  'radex.hero.learnMore': 'Scopri di più',
  'radex.hero.visitWebsite': 'Visita il Sito Web',
  'radex.hero.partnership': 'Opportunità di Investimento Esclusive',
  'radex.hero.benefit1': 'Broker Autorizzato e Regolamentato',
  'radex.hero.benefit2': 'Tecnologia di Trading all\'Avanguardia',
  'radex.hero.benefit3': 'Protocolli di Sicurezza Avanzati',
  'radex.hero.benefit4': 'Vantaggi Esclusivi per i Membri di The Club',
  
  'radex.about.title': 'Info su Radex Markets',
  'radex.about.subtitle': 'Un broker regolamentato impegnato nella sicurezza, trasparenza e tecnologia di trading all\'avanguardia',
  'radex.about.establishmentTitle': 'Presenza Consolidata',
  'radex.about.establishmentText': 'RADEX MARKETS è stata fondata nel 2019 e ha sede nella Repubblica delle Seychelles. Opera sotto il nome commerciale di GO Markets International Ltd, una società costituita nella Repubblica delle Seychelles con numero di registrazione 8425985-1.',
  'radex.about.regulationTitle': 'Autorizzato e Regolamentato',
  'radex.about.regulationText': 'L\'azienda è autorizzata e regolamentata dalla Financial Services Authority delle Seychelles (FSA) con il numero di licenza di Securities Dealer SD043, garantendo un ambiente di trading sicuro e conforme.',
  'radex.about.technologyTitle': 'Tecnologia Avanzata',
  'radex.about.technologyText': 'Radex Markets offre tecnologia all\'avanguardia e un ambiente di trading competitivo progettato per soddisfare le esigenze dei trader moderni, con esecuzioni affidabili e strumenti professionali.',
  'radex.about.transparencyTitle': 'Trasparenza e Fiducia',
  'radex.about.transparencyText': 'La trasparenza è un valore fondamentale di Radex, dimostrato attraverso una comunicazione chiara, onesta e multilingue. Rinomata per la sua integrità, Radex Markets si distingue come piattaforma sicura e affidabile per i trader che cercano affidabilità.',
  
  'radex.features.title': 'Perché abbiamo scelto Radex Markets?',
  'radex.features.subtitle': 'Sperimenta i vantaggi di fare trading con un broker impegnato nell\'eccellenza',
  'radex.features.security': 'Protezione del Cliente',
  'radex.features.securityText': 'Robusti protocolli di sicurezza per salvaguardare i fondi dei clienti e i dati personali, garantendo un ambiente di trading sicuro.',
  'radex.features.technology': 'Piattaforma all\'Avanguardia',
  'radex.features.technologyText': 'Tecnologia di trading avanzata con esecuzione affidabile e strumenti professionali per trader di tutti i livelli.',
  'radex.features.transparency': 'Piena Trasparenza',
  'radex.features.transparencyText': 'Comunicazione chiara e onesta e esecuzione affidabile delle operazioni, mantenendo i più alti standard di trasparenza.',
  'radex.features.global': 'Accesso Globale',
  'radex.features.globalText': 'Supporto e servizi multilingue per trader di diverse regioni e background.',
  
  'radex.partnership.title': 'The Club e Partnership con Radex Markets',
  'radex.partnership.description': 'La nostra partnership strategica con Radex Markets ci permette di offrire opportunità di investimento uniche ai membri del nostro club, combinando la nostra esperienza con un broker regolamentato e affidabile.',
  'radex.partnership.details': 'Attraverso questa collaborazione, i membri di The Club ottengono accesso a condizioni di trading esclusive, gestione avanzata degli account e supporto specializzato da entrambe le organizzazioni. La partnership tra Radex Markets e The Club è costruita su valori condivisi di trasparenza, sicurezza e fornitura di valore eccezionale alla nostra comunità.',
  'radex.partnership.contactUs': 'Contattaci per Dettagli',
  'radex.partnership.visitRadex': 'Visita Radex Markets',
  'radex.partnership.benefitsTitle': 'Vantaggi della Partnership',
  'radex.partnership.benefit1Title': 'Sicurezza Avanzata',
  'radex.partnership.benefit1Text': 'Fai trading con fiducia sapendo che i tuoi fondi sono protetti dai robusti protocolli di sicurezza di Radex Markets.',
  'radex.partnership.benefit2Title': 'Prodotti Esclusivi',
  'radex.partnership.benefit2Text': 'Accedi a prodotti di investimento specializzati e condizioni di trading disponibili solo per i membri di The Club.',
  'radex.partnership.benefit3Title': 'Supporto Professionale',
  'radex.partnership.benefit3Text': 'Ricevi assistenza dedicata dai team di The Club e Radex Markets per un\'esperienza di trading avanzata.',
  
  // Documentation translations
  'docs.title': 'Documentazione API',
  'docs.introduction': 'Introduzione',
  'docs.introDescription': 'Questa applicazione utilizza GraphQL come un livello flessibile di accesso ai dati, alimentato dall\'estensione pg_graphql in Supabase.',
  'docs.benefits': 'I benefici di questo approccio includono:',
  'docs.benefitDecoupling': 'Disaccoppiamento del frontend dall\'accesso diretto al database',
  'docs.benefitTypeSafety': 'Forte sicurezza dei tipi attraverso l\'applicazione',
  'docs.benefitFlexibility': 'Flessibilità per cambiare implementazioni backend con modifiche minime',
  'docs.architecture': 'Panoramica dell\'Architettura',
  'docs.architectureDescription': 'L\'applicazione utilizza un\'architettura a strati che separa le responsabilità e fornisce flessibilità:',
  'docs.serviceLayer': 'Livello di Astrazione del Servizio',
  'docs.serviceLayerDescription': 'Il livello di servizio fornisce un\'interfaccia coerente indipendentemente dall\'implementazione sottostante, permettendo all\'applicazione di passare tra chiamate dirette a Supabase e query GraphQL senza modificare il codice dell\'applicazione.',
  'docs.schema': 'Schema GraphQL',
  'docs.schemaDescription': 'Lo schema GraphQL è generato automaticamente dalla struttura del database da pg_graphql, con alcuni resolver personalizzati per esigenze specifiche:',
  'docs.implementationGuide': 'Guida all\'Implementazione',
  'docs.frontendImplementation': 'Implementazione Frontend',
  'docs.frontendImplementationDescription': 'Per interagire con l\'API GraphQL dal frontend, utilizza Apollo Client:',
  'docs.serviceFactory': 'Factory di Servizi',
  'docs.serviceFactoryDescription': 'Il pattern factory di servizi permette di passare facilmente tra diverse implementazioni di servizi:',
  'docs.switchingBackends': 'Cambio di Backend',
  'docs.switchingBackendsDescription': 'Per passare tra diverse implementazioni di backend, chiama la funzione setServiceImplementation:',
  'docs.backendImplementation': 'Implementazione Backend',
  'docs.backendImplementationDescription': 'Il backend utilizza Supabase con l\'estensione pg_graphql per fornire un\'API GraphQL:',
  'docs.pgGraphql': 'Estensione pg_graphql',
  'docs.pgGraphqlDescription': 'L\'estensione pg_graphql genera automaticamente un\'API GraphQL dal tuo schema di database:',
  'docs.alternativeBackends': 'Backend Alternativi',
  'docs.alternativeBackendsDescription': 'Per implementare backend alternativi, crea nuove implementazioni di servizi che si conformino alle interfacce di servizio definite nella factory di servizi.',

  //Error translations
  'error.defaultTitle': 'Si è verificato un errore',
  'error.defaultMessage': ' ',
  'error.profileInvalidTitle': 'Si è verificato un errore', 
  'error.profileInvalidMessage': 'Il profilo utente non è valido',
  'error.goHome': 'Vai alla Home',
  'error.contactSupport': 'Contatta il Supporto',
};

const calendar = {
  'calendar.january': 'Gennaio',
  'calendar.february': 'Febbraio',
  'calendar.march': 'Marzo',
  'calendar.april': 'Aprile',
  'calendar.may': 'Maggio',
  'calendar.june': 'Giugno',
  'calendar.july': 'Luglio',
  'calendar.august': 'Agosto',
  'calendar.september': 'Settembre',
  'calendar.october': 'Ottobre',
  'calendar.november': 'Novembre',
  'calendar.december': 'Dicembre',
  'calendar.months.january': 'Gen',
  'calendar.months.february': 'Feb',
  'calendar.months.march': 'Mar',
  'calendar.months.april': 'Apr',
  'calendar.months.may': 'Mag',
  'calendar.months.june': 'Giu',
  'calendar.months.july': 'Lug',
  'calendar.months.august': 'Ago',
  'calendar.months.september': 'Set',
  'calendar.months.october': 'Ott',
  'calendar.months.november': 'Nov',
  'calendar.months.december': 'Dic',
  'calendar.weekdays.monday': 'Lu',
  'calendar.weekdays.tuesday': 'Ma',
  'calendar.weekdays.wednesday': 'Me',
  'calendar.weekdays.thursday': 'Gi',
  'calendar.weekdays.friday': 'Ve',
  'calendar.weekdays.saturday': 'Sa',
  'calendar.weekdays.sunday': 'Do',
};

export default {
  ...common,
  ...calendar,
};
